import { render, staticRenderFns } from "./SettingDia.vue?vue&type=template&id=f08c618c"
import script from "./SettingDia.vue?vue&type=script&lang=js"
export * from "./SettingDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports